export default __webpack_public_path__ + "static/media/avatar.ca0ac32c.png";